import {AdminPagingModel} from "./AdminPagingModel";
import {Reader} from "../../entities/Reader";
import {ReaderService} from "../../services/ReaderService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";

export class ReaderAdminPagingModel extends AdminPagingModel<Reader>{
    static $inject = ['$q','ReaderService','NotificationService','GridBookmarkService'];
    constructor($q:ng.IQService, pagingService:ReaderService,notificationService:NotificationService,
                gridBookmarkService:GridBookmarkService){
        super($q, pagingService, notificationService,gridBookmarkService);
    }
    getCustomActions():string[]{
        return [];
    }
    entityName():string{
        return "reader";
    }
    displayName():string{
        return "Readers";
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs = [
            ['name','Name', 150],
            ['readerModel', 'Reader Model', 200],
            ['useWithService', 'Use With Service', 200],
            ['lastSeen', 'Last Seen', 200],
            ['ipAddress', 'IP Address', 200]
        ];
        return this.$q.when();
    }
}
